import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Container, Segment } from 'semantic-ui-react';

import { CmsPageLayout } from '../../cms/CmsPage';
import { useCurrentUser } from '../../shared/store-user.hooks';
import { replaceUriValues } from '../../utils/stringUtils';
import { Browser, detectBrowser } from '../../utils/userAgentUtils';
import IframePage from '../IframePage';
import './MementoIframePage.scss';

const MementoIframePage: React.FC = (props: any) => {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const url = 'https://valueup2026-cn.events.3ds.com/cdnApi/custom/v1/{eventId}/memento/k/{privateKey}';

  // If the user has a safari browser, we need to show a button :/
  if (detectBrowser() === Browser.Safari) {
    const { header, metadata, pageId, design, pageHeader, pageFooter } = props;

    return (
      <CmsPageLayout
        className={cx('page', 'page--memento', pageId)}
        header={header}
        metadata={metadata}
        designOverride={design}
        pageHeader={pageHeader}
        pageFooter={pageFooter}
      >
        <Container className="memento-container">
          <Segment placeholder className="memento-segment">
            <p className="memento-description">{t('memento.description')}</p>
            <Button
              className="memento-access-button"
              primary
              size="large"
              as="a"
              target="_blank"
              href={replaceUriValues(url, user)}
            >
              {t('memento.access-button')}
            </Button>
          </Segment>
        </Container>
      </CmsPageLayout>
    );
  }

  return <IframePage {...props} url={url} />;
};

export default MementoIframePage;
